/* @pareto-engineering/generator-front 1.0.12 */
import { urljoin as _u } from 'utils'

export const basePath = '/case-studies'

export default {
  MATS:_u(basePath, 'debate-judgment-mats'),
  // CHARACTER_AI:_u(basePath, 'character-ai'),
}
